import dayjs from 'dayjs';
import React from 'react';
import { Button, Tag } from '@carbon/react';
import { Delivery, PhoneOutgoing } from '@carbon/react/icons';
import { useMoney } from 'src/hooks/useMoney';
import { useBranches } from 'src/hooks/useRestaurantBranches';
import { OrderEntity } from 'src/services/apis/types';
import { clickable } from 'src/utils/a11y';

interface DeliveryOrderItemProps {
  order: OrderEntity;
  onView: (order: OrderEntity) => void;
  paidOrderTokens?: string[];
}

const DeliveryOrderItem = React.memo((props: DeliveryOrderItemProps) => {
  const { format } = useMoney();
  const { data: branches } = useBranches();

  const transformedBranches = branches?.data.reduce((previousObject, currentObject) => {
    return Object.assign(previousObject, {
      [currentObject.id]: currentObject.name,
    });
  }, {});

  return (
    <div className={'delivery-order-item'} {...clickable(() => props.onView(props.order))}>
      <div className="table">
        <Delivery size={48} />
      </div>
      <div className={'info'}>
        <h5>{props.order.phoneNumber}</h5>
        <h4>{props.order.line1}</h4>
        <ul className="list-horizontal">
          <li>{dayjs(props.order.createdAt).fromNow()}</li>
        </ul>
        <div className="actions">
          <a href={`tel:${props.order.phoneNumber}`}>
            <Button size={'sm'} renderIcon={PhoneOutgoing} kind={'danger'} />
          </a>
        </div>
      </div>
      <Tag className="pos-recent-orders-item-status" type="red" title="Clear Filter">
        {transformedBranches && transformedBranches[props.order.restaurantBranchId]} | {format(props.order.grandTotal)}
      </Tag>
    </div>
  );
});

export default DeliveryOrderItem;
